var map = {
	"./01_Isabelle Ihl Architektur_Fachmodul_Modellfoto.jpg": 8006,
	"./02_Isabelle Ihl Architektur_Fachmodul_Grundriss.jpg": 1115,
	"./03_Isabelle Ihl Architektur_Fachmodul_Schnitt.jpg": 8163,
	"assets/c3_hikinghouse/01_Isabelle Ihl Architektur_Fachmodul_Modellfoto.jpg": 8006,
	"assets/c3_hikinghouse/02_Isabelle Ihl Architektur_Fachmodul_Grundriss.jpg": 1115,
	"assets/c3_hikinghouse/03_Isabelle Ihl Architektur_Fachmodul_Schnitt.jpg": 8163
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4847;